import { Box, Image, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import ContactUs from '../../comps/ContactUs'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { staticStrings } from '../../static/staticStrings'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { styles } from './styles'

const AboutUs: FC = () => {
  const [navVisible, setNavVisible] = useState(false)
  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }
  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  const respPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)
  const themedStyle = styles(width, respPadding)
  const { headerSize, textSize, textLineHeight } = useFontSize()
  return (
    <>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar onPress={handleNav} isLightBackground={true} />
      <Box {...themedStyle.outerontainer}>
        <Box {...themedStyle.container}>
          <Box {...themedStyle.leftBox}>
            <Text fontSize={headerSize} fontFamily="jiotype-black" title={'About Us'} />
            <Spacer direction={'vertical'} size={isMobile ? 24 : 32} />
            <Box width="100%">
              <Text
                lineHeight={textLineHeight}
                fontSize={textSize}
                color={'PRIMARY_GREY'}
                fontFamily={'jiotype-medium'}
                title={staticStrings.aboutUs}
              />
            </Box>
            <Spacer direction={'vertical'} size={isMobile || isTab ? 40 : 56} />
            <Image
              source={require('../../assets/images/payments.png')}
              width={'100%'}
              height={32}
              resizeMode={'center'}
            />
          </Box>
          <Box {...themedStyle.imageContainer}>
            <Image
              source={require('../../assets/images/about-us.png')}
              height={isMobile || isTab ? 240 : 478}
              width={isMobile || isTab ? 244 : 486}
            />
          </Box>
        </Box>
        <Spacer direction={'vertical'} size={32} />
        <ContactUs type={'footer'} />
      </Box>
    </>
  )
}

export { AboutUs as default }
